module.exports = {
  accountCreation: { path: '/login/account-creation', label: 'Register' },
  checkoutSignUp: { path: '/login/checkout-signup', label: 'Register' },
  emailSubmission: { path: '/login/email-submission', label: 'Sign In' },
  forgottenPassword: {
    path: '/login/forgotten-password',
    label: 'Forgotten Password',
  },
  guestCheckout: { path: '/login/guest-checkout', label: 'Guest Checkout' },
  login: { path: '/login', label: 'Sign In/ Sign Up' },
  notFound: { path: '/not-found', label: 'Not Found' },
  passwordSignUp: { path: '/login/password-signup', label: 'Register' },
  passwordValidation: { path: '/login/password-validation', label: 'Sign In' },
  redirect: { path: '/login/redirect', label: 'Redirect' },
  resetPassword: { path: '/login/reset-password', label: 'Reset Password' },
};
